import { HttpStatusCode } from "axios";
import { z } from "zod";

const httpStatusCodeSchema = z.nativeEnum(HttpStatusCode);

const serviceErrorDetailsSchema = z.object({
    StatusCode: httpStatusCodeSchema,
    Message: z.string(),
    CorrelationID: z.string().optional()
});

export type ServiceErrorDetails = z.infer<typeof serviceErrorDetailsSchema>;

export function isServiceErrorDetails(error: unknown): error is ServiceErrorDetails {
    return serviceErrorDetailsSchema.safeParse(error).success;
}
